module.exports = new __parcel__URL__("hand_pointing_9_oclock.f5941661.png").toString();